(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ls-qa]');
    if (!form) return;
    e.preventDefault();
    var select = form.querySelector('select[name="id"]');
    var btn = form.querySelector('button');
    if (!select.value) { select.focus(); select.classList.add('is-missing'); return; }
    select.classList.remove('is-missing');
    btn.disabled = true;
    var old = btn.textContent; btn.textContent = 'Adding';
    var fd = new FormData();
    fd.append('id', select.value);
    fd.append('quantity', '1');
    var drawer = document.querySelector('cart-drawer');
    if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
    }).then(function (r) { return r.json(); }).then(function (res) {
      btn.disabled = false; btn.textContent = old;
      if (res.status) { btn.textContent = 'Try again'; return; }
      if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    }).catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  });
})();
